import { render, staticRenderFns } from "./r-panel-header.vue?vue&type=template&id=3e9e3162"
import script from "./r-panel-header.vue?vue&type=script&lang=js"
export * from "./r-panel-header.vue?vue&type=script&lang=js"
import style0 from "./r-panel-header.vue?vue&type=style&index=0&id=3e9e3162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports